(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcement = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'search-on-scroll-up';
      this.headerShowSearchBar = this.getAttribute('data-sticky-type') === 'search-on-scroll-up';
      this.headerBounds = {};
      this.headerMenu = this.header.querySelector(".header__inline-menu");
      if (this.headerMenu) {
        this.isMenuOpen = false;

        if (this.headerMenu) {
          this.headerMenu.addEventListener('mouseover', this.handleMenuMouseOver.bind(this));
          this.headerMenu.addEventListener('mouseout', this.handleMenuMouseOut.bind(this));
        }
      }

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--announcement-height', `0px`);
      if (this.announcement && !this.header.classList.contains(".scrolled-past-header")) {
        document.documentElement.style.setProperty('--announcement-height', `${this.announcement.offsetHeight}px`);
      } 
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcement && !this.header.classList.contains(".scrolled-past-header")) {
          document.documentElement.style.setProperty('--announcement-height', `0px`);
        } 
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.announcement && !this.header.classList.contains(".scrolled-past-header")) {
          document.documentElement.style.setProperty('--announcement-height', `0px`);
        } 
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
            document.documentElement.style.setProperty('--header-height', `0px`);
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.announcement && !this.header.classList.contains(".scrolled-past-header")) {
          document.documentElement.style.setProperty('--announcement-height', `${this.announcement.offsetHeight}px`);
        } 
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerShowSearchBar) this.header.classList.add('shopify-section-search-hidden');
      if (this.headerIsAlwaysSticky) return;
      document.documentElement.style.setProperty('--header-height', `0px`);
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerShowSearchBar) this.header.classList.remove('shopify-section-search-hidden');
      if (this.headerIsAlwaysSticky) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerShowSearchBar) this.header.classList.add('shopify-section-search-hidden');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }

    handleMenuMouseOver(event) {
      // Check if the target is the <header-menu> tag
      const headerMenuTag = event.target.closest('header-menu');
      if (headerMenuTag) {
        const detailsElement = headerMenuTag.querySelector('details');

        // Only open the menu if it's not already open
        if (!detailsElement.hasAttribute('open')) {
          this.openMenu(detailsElement);
        }
      }
    }

    handleMenuMouseOut(event) {
      const headerMenuTag = event.target.closest('header-menu');
      if (headerMenuTag) {
        const detailsElement = headerMenuTag.querySelector('details');
        
        if (!detailsElement.contains(event.relatedTarget)) {
          this.closeMenu(detailsElement);
        }
      }
    }

    openMenu(detailsElement) {
      detailsElement.setAttribute('open', true);
    }

    closeMenu(detailsElement) {
      detailsElement.removeAttribute('open');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
